import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { REQUIRE_VISITOR_LOGIN } from '../config/auth';
import { isLoggedIn } from '../utils/session';

/** 须登录后方可浏览 */
export default function ProtectedRoute({ children }) {
  const location = useLocation();
  if (REQUIRE_VISITOR_LOGIN && !isLoggedIn()) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  return children;
}
